import React from 'react';
import { FreeTrialSection } from './Partial/FreeTrialSection/FreeTrialSection';
import { DescriptionSection } from './Partial/DescriptionSection/DescriptionSection';
import { FeaturesSection } from './Partial/FeaturesSection/FeaturesSection';
import { ExpertiseSection } from './Partial/ExpertiseSection/ExpertiseSection';
import { PromoSection } from './Partial/PromoSection/PromoSection';
import './Landing.scss';

const Landing = () => {
  return (
    <div id="landing">
      <FreeTrialSection />
      <DescriptionSection />
      <FeaturesSection />
      <ExpertiseSection />
      <PromoSection />
    </div>
  );
};

export default Landing;



// WEBPACK FOOTER //
// ./src/containers/Landing/Landing.js